import type { Transaction } from "@/types/bridge-scanner.types";
import { statusIconResolve } from "@/utils/status-icon-resolve.util";
import React from "react";
import styles from "./index.module.scss";
import BridgeTooltip from "@/components/layout/tooltip";

type Props = {
  status: Transaction["status"];
  showText?: boolean;
};

const TransactionStatus = ({ status, showText = false }: Props) => {
  const { icon, text } = statusIconResolve(status);

  return (
    <div className={styles.container}>
      <BridgeTooltip text={text}>
        {icon} {showText && text}
      </BridgeTooltip>
    </div>
  );
};

export default TransactionStatus;
